import { render, staticRenderFns } from "./CartOrderDetails.vue?vue&type=template&id=43f07956&lang=pug&"
import script from "./CartOrderDetails.vue?vue&type=script&lang=js&"
export * from "./CartOrderDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports